import { cn } from "@/shared/lib/cn";
import { cva, type VariantProps } from "class-variance-authority";
import { motion, type MotionProps } from "framer-motion";
import type { ButtonHTMLAttributes } from "react";

const buttonVariants = cva("rounded-[10px] text-sm font-medium", {
	variants: {
		variant: {
			default: "bg-bg-regular text-ct-regular",
			inverted: "bg-bg-inverted text-ct-inverted",
			primary: "bg-pm-strong text-ct-elevated",
			danger: "bg-dg-weak text-dg-strong",
		},
		size: {
			sm: "px-[16px] py-[10px]",
			md: "px-[16px] py-[12px]",
			lg: "px-[20px] py-[16px]",
		},
	},
	defaultVariants: {
		variant: "default",
		size: "md",
	},
});

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
	VariantProps<typeof buttonVariants> &
	MotionProps;

export const Button = ({ variant, size, className, children, ...props }: ButtonProps) => (
	<motion.button className={cn(buttonVariants({ variant, size, className }))} {...props}>
		{children}
	</motion.button>
);
